
<div class=" d-none d-sm-block">
	<!------------------------------------------TITLE----------------------------------------------->
	<div class="title-box uk-border-rounded p-1 d-none d-sm-block">
		<div class="head-card p-1 inner-title-box">
		  <h1 class="title-text text-center font-weight-bold">
			MULTI BRAND PISTON COMPRESSOR
		  </h1>
		  <div class="text-right">
			<h5 class="text-light">
				<span class="sub-menu" routerLink="/home-page">HOME </span>&nbsp;
				<span class="sub-menu" routerLink="/contact-us"> CONTACT</span>&nbsp;
				<span class="sub-menu" routerLink="/ourproducts"> PRODUCTS</span>&nbsp;
				<span class="sub-menu" routerLink="/verticals"> SERVICES</span>&nbsp;
			</h5>
		  </div>
		</div>
	   </div>

	  <!--------------------------------------------------TITLE END-------------------------------------------->
	<!------------------------------------------------------------CAROSUEL----------------------------------------------------->
	<div class="content-container">   
		<a class="mail-call" href="tel:8489359948">
            <span class="fa fa-phone" aria-hidden="true"></span>
        </a>  
		<a class="mail-call1" href="mailto:rvproduction2017@gmail.com"><span class="fa fa-envelope"></span>
		</a>   
		<a class="mail-call2" href="https://wa.me/8489359948" target="_blank">
			<span class="fa fa-whatsapp"></span>
		</a>
        <img src="../../../assets/img/slides img/piston-air-compressor.jpeg" alt="">
        <br>
        <ul>
            <li>Quick Response Time – We understand how critical your equipment is to your operations, 
                and we respond quickly to minimize downtime.</li>
            <li>Experienced and Certified Technicians – Our team is trained and certified to work on 
                various compressor models and ensures the highest standards of service..</li>
            <li>&nbsp; Affordable and Transparent Pricing – We offer competitive prices with no hidden fees. Get clear estimates before we start the job..</li>
            <li>Genuine Parts and High-Quality Service – We only use OEM (Original Equipment Manufacturer) parts to maintain the quality and integrity of your compressor..</li>
        </ul>



        <p>
            A piston compressor is a positive displacement compressor where a piston moves back and forth inside a cylinder to compress air or gas. 
            These compressors are widely used in various industries due to their reliability and efficiency.
        </p>
        <p>
            Regular maintenance ensures optimal performance, increases the lifespan of your compressor, and helps prevent costly breakdowns.
        </p>
    </div>
</div>




<!--------------------------------------- MOBILE VIEW ------------------------------------------------->

<div class=" d-block d-sm-none">
	<a class="mail-call" href="tel:8489359948">
		<span class="fa fa-phone" aria-hidden="true"></span>
	</a>  
	<a class="mail-call1" href="mailto:rvproduction2017@gmail.com"><span class="fa fa-envelope"></span>
	</a>   
	<a class="mail-call2" href="https://wa.me/8489359948" target="_blank">
		<span class="fa fa-whatsapp"></span>
	</a>
    <img src="../../assets/img/multi-brand/multibrand2.webp" alt="">
    <br>
    <ul>
        <li>Quick Response Time – We understand how critical your equipment is to your operations, 
            and we respond quickly to minimize downtime.</li>
        <li>Experienced and Certified Technicians – Our team is trained and certified to work on 
            various compressor models and ensures the highest standards of service..</li>
        <li>&nbsp; Affordable and Transparent Pricing – We offer competitive prices with no hidden fees. Get clear estimates before we start the job..</li>
        <li>Genuine Parts and High-Quality Service – We only use OEM (Original Equipment Manufacturer) parts to maintain the quality and integrity of your compressor..</li>
    </ul>



    <p>
        A piston compressor is a positive displacement compressor where a piston moves back and forth inside a cylinder to compress air or gas. 
        These compressors are widely used in various industries due to their reliability and efficiency.
    </p>
    <p>
        Regular maintenance ensures optimal performance, increases the lifespan of your compressor, and helps prevent costly breakdowns.
    </p>
    </div>
